import React from "react";

const Footer = () => {

    return(
      <>
        <footer className="footer">
          <div className="footer-inner">
            <div className="footer-address">
              <h2>(주)에스마리나</h2>
              <address>
                <p>
                  <span>사업자 등록번호 : 246-81-02490</span>
                  <i>|</i>
                  <span>대표 : 서영태</span>
                  <i>|</i>
                  <span>Tel : 010-3560-0880</span>
                  <i>|</i>
                  <span>Email : ytseo@sMarina.co.kr</span>
                  <br />
                  <span>주소 : 경기도 광명시 일직로 43, GIDC A동 2210호</span>
                </p>
              </address>
            </div>
          </div>
        </footer>
      </>
    );
}

export default Footer;